/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import ReactSelect from 'react-select';
import { Button, Input, Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const VWPagination = ({ pager, setPage, totalRecords = 0, pageSize = 1, setPageSize }) => {
  const options = [
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "30", value: 30 },
    { label: "40", value: 40 },
    { label: "50", value: 50 },
  ]

  let currentPageCount;
  if (totalRecords !== 0) {
    if (pager.totalPages === pager.currentPage) {

      const remainder = totalRecords % pageSize;
      if (remainder === 0) {
        currentPageCount = pageSize;
      }
      else {
        currentPageCount = remainder;
      }
    }
    else {
      currentPageCount = pageSize;
    }
  }
  else {
    currentPageCount = 0;
  }

  let startIndex = (((pager.currentPage * pageSize) + 1) - pageSize);
  if (totalRecords === 0) {
    startIndex = 0;
  }
  let endIndex = (pager.currentPage * pageSize);
  if (endIndex > totalRecords) {
    endIndex = totalRecords;
  }
  return (
    <div className='d-flex justify-content-between'>
      <div className='d-flex gap-2 align-items-center'>
        <div>
          Rows Per Page
        </div>
        <ReactSelect
          options={options}
          styles={{
            menu: (baseStyles) => ({
              ...baseStyles,
              zIndex: "10"
            })
          }}
          menuPlacement='top'
          value={{ label: pageSize, value: pageSize }}
          onChange={(value) => {
            const selectedValue = value && value.value
            setPageSize(selectedValue)
          }}
        />
      </div>
      <div className="d-flex align-items-center">
        <div className='m-3'>
          {startIndex} - {endIndex} of {totalRecords}
        </div>
        {/* <Pagination className="pagination-sm bg-warning mt-2 border-danger border">
          <PaginationItem disabled={pager.currentPage === 1} className="bg-info">
            <PaginationLink onClick={() => setPage(1)} previous />
          </PaginationItem>
          <PaginationItem disabled={pager.currentPage === 1}>
            <PaginationLink onClick={() => setPage(pager.currentPage - 1)}>‹</PaginationLink>
          </PaginationItem>
          {pager.pages &&
            pager.pages.map((page, i) => (
              <PaginationItem active={pager.currentPage === page} key={i}>
                <PaginationLink onClick={() => setPage(page)}>{page}</PaginationLink>
              </PaginationItem>
            ))}
          <PaginationItem disabled={pager.currentPage === pager.totalPages}>
            <PaginationLink onClick={() => setPage(pager.currentPage + 1)}>›</PaginationLink>
          </PaginationItem>
          <PaginationItem disabled={pager.currentPage === pager.totalPages}>
            <PaginationLink onClick={() => setPage(pager.totalPages)} next />
          </PaginationItem>
        </Pagination> */}
        <div>
          <div className="d-inline-block">
            <ul className="pagination pagination-rounded mb-0">
              <li className="page-item">
                <Button
                  className={`page-link border border-2 ${pager.currentPage === 1 ? 'border-secondary' : 'border-primary'}`}
                  aria-label="Previous"
                  onClick={() => setPage(1)}
                  disabled={pager.currentPage === 1}>
                  <i className={`mdi mdi-chevron-double-left ${pager.currentPage === 1 ? 'text-secondary' : 'text-primary'} fs-2 fw-bold`}></i>
                </Button>
              </li>
              <li className="page-item">
                <Button
                  className={`page-link border border-2 ${pager.currentPage === 1 ? 'border-secondary' : 'border-primary'}`}
                  aria-label="Previous"
                  onClick={() => setPage(pager.currentPage - 1)}
                  disabled={pager.currentPage === 1}>
                  <i className={`mdi mdi-chevron-left ${pager.currentPage === 1 ? 'text-secondary' : 'text-primary'} fs-2 fw-bold`}></i>
                </Button>
              </li>
              {pager.pages &&
                pager.pages.map((page, i) => (
                  <li className={pager.currentPage === page ? "page-item active" : "page-item"}>
                    <Button
                      className="page-link border-2 border border-primary"
                      onClick={() => setPage(page)}>
                      <div className={pager.currentPage === page ? 'text-white fw-bold' : 'text-primary fw-bold'}> {page}</div>
                    </Button>
                  </li>
                ))}
              <li className="page-item">
                <Button
                  className={`page-link border border-2 ${pager.currentPage === pager.totalPages ? 'border-secondary' : 'border-primary'}`}
                  aria-label="Next"
                  onClick={() => setPage(pager.currentPage + 1)}
                  disabled={pager.currentPage === pager.totalPages}>
                  <i className={`mdi mdi-chevron-right ${pager.currentPage === pager.totalPages ? 'text-secondary' : 'text-primary'} fw-bold fs-2`}></i>
                </Button>
              </li>
              <li className="page-item">
                <Button
                  className={`page-link border border-2 ${pager.currentPage === pager.totalPages ? 'border-secondary' : 'border-primary'}`}
                  aria-label="Next"
                  onClick={() => setPage(pager.totalPages)}
                  disabled={pager.currentPage === pager.totalPages}>
                  <i className={`mdi mdi-chevron-double-right ${pager.currentPage === pager.totalPages ? 'text-secondary' : 'text-primary'} fw-bold fs-2`}></i>
                </Button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  );
};

export default VWPagination;
